import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/constants";
import { Card, LoadingBlock } from "@/components/common";

export default function AuditTab() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/audit-log").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);
  if (!rows) return <LoadingBlock />;
  return (
    <Card title="Audit log" subtitle="Who changed what, newest first." testid="audit-tab">
      {!rows.length ? <p className="text-sm text-slate-400">Nothing has been changed yet.</p> : (
        <div className="max-h-[600px] overflow-y-auto">
          <table className="w-full text-sm">
            <thead><tr className="border-b text-left text-xs uppercase text-slate-400"><th className="py-2">When</th><th>Who</th><th>What</th><th>Details</th></tr></thead>
            <tbody>{rows.map((r) => (
              <tr key={r.id} className="border-b border-slate-100 align-top">
                <td className="whitespace-nowrap py-2.5 pr-3 text-slate-500">{fmtDateTime(r.at)}</td>
                <td className="pr-3">{r.user_email}</td>
                <td className="pr-3 font-medium">{r.action}{r.target ? <div className="text-xs font-normal text-slate-400">{r.target}</div> : null}</td>
                <td className="text-slate-600">{r.details}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
